import React, { useState } from 'react';
import { Heading, SectionLabel } from '../components/ui-bits';
import CTABanner from '../components/CTABanner';
import { JOURNAL_POSTS } from '../data/mock';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CATS = ['All','Destination Guides','Planning Guides','Wedding Budgets','Venue Guides','Real Weddings','Wedding Professionals'];

export default function Journal() {
  const [cat, setCat] = useState('All');
  const filtered = cat === 'All' ? JOURNAL_POSTS : JOURNAL_POSTS.filter(p => p.category === cat);

  return (
    <main className="pt-32">
      <section className="max-w-[1240px] mx-auto px-6 md:px-10 py-16">
        <SectionLabel>Journal</SectionLabel>
        <Heading className="mt-5 font-serif max-w-3xl">Plan Better. <span className="italic">Dream Bigger.</span></Heading>
        <p className="mt-6 max-w-2xl text-[#4a5c60] text-lg">Explore ideas and practical guidance from Sunday Mirror.</p>
        <div className="mt-10 flex flex-wrap gap-2">
          {CATS.map((c) => (
            <button key={c} onClick={()=>setCat(c)} className={`px-4 py-2 text-xs tracking-wide border transition-colors ${cat===c ? 'bg-[#053e49] text-[#ffeabf] border-[#053e49]':'border-[#e8e0d2] text-[#053e49] hover:border-[#c3a66d]'}`}>{c}</button>
          ))}
        </div>
      </section>

      <section className="max-w-[1340px] mx-auto px-6 md:px-10 pb-24">
        <div className="grid md:grid-cols-2 gap-x-10 gap-y-16">
          {filtered.map((p, i) => (
            <Link to="/journal" key={p.title} className="group">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-110" />
              </div>
              <div className="mt-5 eyebrow text-[#a6894f]">{p.category} · {p.read}</div>
              <h3 className="mt-3 font-serif text-3xl text-[#053e49] group-hover:text-[#a6894f] transition-colors">{p.title}</h3>
              <p className="mt-3 text-[#4a5c60]">{p.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-2 eyebrow text-[#a6894f]">Read article <ArrowRight size={14} /></span>
            </Link>
          ))}
        </div>
      </section>

      <CTABanner />
    </main>
  );
}
